import React from "react";
import type { EmployeeItem, RoleItem } from "../../types/employee";
import { Edit } from "lucide-react";
import type { Store } from "../../types/store";


interface Props {
  employee: EmployeeItem;
  selected: boolean;
  onSelect: (id: string, checked: boolean) => void;
  onEdit: (emp: EmployeeItem) => void;
}

const EmployeeCard: React.FC<Props> = ({ employee, selected, onSelect, onEdit }) => {
  const fullName = `${employee.firstname}${employee.lastname ? " " + employee.lastname : ""}`;

  // console.log("Roles:", employee.assignedRoles);

  return (
    <div className={`relative bg-white rounded-2xl border p-4 shadow-sm flex flex-col h-full ${!employee.isActive ? "opacity-50" : ""}`}>
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-center gap-3">
          <input
            type="checkbox"
            checked={selected}
            onChange={(e) => onSelect(employee.id, e.target.checked)}
            className="mt-1"
            aria-label={`Select ${fullName}`}
          />
          <div className="text-left">
            <div className="flex items-center gap-2">
              <h3 className="text-lg font-semibold">
                {fullName}
              </h3>

              {!employee.isActive && (
                <span className="rounded-xl bg-gray-200 border border-gray-800 text-gray-800 px-2 py-0.5 text-xs font-medium">
                  Inactive
                </span>
              )}
            </div>

            <p className="text-xs text-gray-500">
              {employee.email ?? "No email"}
            </p>

            <p className="text-xs text-gray-400">
              {employee.phoneNumber ?? "No phone"}
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <button
            title="Edit employee"
            onClick={() => onEdit(employee)}
            className="p-2 rounded-md hover:bg-gray-100"
          >
            <Edit />
          </button>
        </div>
      </div>

      <div className="mt-4 flex-1 flex flex-col text-left justify-between">
        <div>
          <p className="text-sm text-gray-600">Roles</p>
          <div className="flex flex-wrap gap-2 mt-2">
            {(employee.assignedRoles ?? []).map((r: RoleItem) => (
              <span key={r.id} className="text-xs bg-gray-100 px-2 py-1 rounded-full">
                {r.name}
              </span>
            ))}
            {!(employee.assignedRoles ?? []).length && <span className="text-xs text-gray-400">No roles</span>}
          </div>

          <div className="mt-3">
            <p className="text-sm text-gray-600">Stores</p>
            <div className="flex flex-wrap gap-2 mt-2">
              {(employee.assignedStores ?? []).map((s: Store) => (
                <span key={s.id} className="text-xs bg-gray-50 border px-2 py-1 rounded-full">
                  {s.name}
                </span>
              ))}
              {!(employee.assignedStores ?? []).length && <span className="text-xs text-gray-400">No stores</span>}
            </div>
          </div>
        </div>

        <div className="mt-4 flex items-center justify-between text-xs text-gray-400">
          <span>Registered: {employee.createdAt?.slice(0, 10) ?? "—"}</span>
          <span>Updated: {employee.updatedAt?.slice(0, 10) ?? "—"}</span>
        </div>
      </div>
    </div>
  );
};

export default EmployeeCard;
